// extracted by mini-css-extract-plugin
module.exports = {"status":"StatusView_status__Na568","statusButton":"StatusView_statusButton__26LTn","active":"StatusView_active__15RAZ","archive":"StatusView_archive__2aQbC"};